import { styled } from 'styled-components';
import uploadFileIcon from '@/routes/inspirations/assets/upload-file.svg';

export const Container = styled.div<{ $isDragOver: boolean }>`
	position: relative;
	width: 100%;
	height: 100%;
	/* prettier-ignore */
	background: url("${uploadFileIcon}") center no-repeat;
	background-color: ${({ $isDragOver }) => ($isDragOver ? '#f0f0f0' : '#f5f5f5')};
	cursor: pointer;
`;

export const FileInput = styled.input`
	display: none !important;
`;
